import { List } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { Membership, Memberships } from 'stores/memberships';
import { getUserLabel } from 'utils/get-user-label';

const MemberDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  justify-content: center;
  height: var(--spacing-07);

  & p {
    margin-bottom: 0;
  }
`;

const MemberList = styled(List.Item)`
  padding: var(--spacing-03) var(--spacing-05);

  .ant-list-item-action li {
    padding-right: 0;
  }
`;

export const ListItem: FC<{
  member: User;
  memberships: Memberships;
  loggedInUserPermissions: Membership | undefined;
  projectId: number;
}> = ({ member }) => {
  if (member) {
    return (
      <MemberList>
        <List.Item.Meta
          avatar={
            <Avatar
              size="large"
              src={member.photoUrl}
              name={getUserLabel(member)}
            />
          }
          title={<MemberDetails>{getUserLabel(member) || '-'}</MemberDetails>}
          description={member.role && member.role.roleDescription}
        />
      </MemberList>
    );
  }

  return <></>;
};
